import React from 'react';
import PropTypes from 'prop-types';

import ClosedExposureLimitDialogFormik from '~/components/SystemConfiguration/Tabs/PaymentsConfiguration/PaymentConfigTab/AdditionalDialogs/ClosedExposureLimitDialog/ClosedExposureLimitDialogFormik';
import { PAYMENTS_CONFIG_FIELDS } from '~/components/SystemConfiguration/Tabs/PaymentsConfiguration/PaymentConfigTab/constants';

const FIELD_IDS = {
  IS_EXPENSES_LIMIT_FOR_CLOSED_EXPOSURE_ENABLED: PAYMENTS_CONFIG_FIELDS.IS_EXPENSES_LIMIT_FOR_CLOSED_EXPOSURE_ENABLED,
  EXPENSES_LIMIT_FOR_CLOSED_EXPOSURE: PAYMENTS_CONFIG_FIELDS.EXPENSES_LIMIT_FOR_CLOSED_EXPOSURE,
};

const ClosedExposureExpensesLimitDialog = ({ paymentsConfiguration, disabled = false, onCancel, onSubmit }) => {
  return (
    <ClosedExposureLimitDialogFormik
      paymentsConfiguration={paymentsConfiguration}
      limitType="expenses"
      switchFormikId={FIELD_IDS.IS_EXPENSES_LIMIT_FOR_CLOSED_EXPOSURE_ENABLED}
      limitFormikId={FIELD_IDS.EXPENSES_LIMIT_FOR_CLOSED_EXPOSURE}
      disabled={disabled}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  );
};

ClosedExposureExpensesLimitDialog.propTypes = {
  paymentsConfiguration: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

export default ClosedExposureExpensesLimitDialog;
